/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosError } from 'axios';
import { SearchFunction, SearchResults } from '@components/TypeaheadSearch/types';

/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

interface SearchParam<T> {
  query: string;
  searchFunction: SearchFunction<T>;
  setSearchError: (error?: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  setResults: (results?: SearchResults<T>) => void;
}
export const searchAndUpdateUI = async <T>({
  query,
  setSearchError,
  setResults,
  setIsLoading,
  searchFunction,
}: SearchParam<T>) => {
  setIsLoading(true);
  setSearchError();
  try {
    const results = await searchFunction(query);
    setResults(results);
  } catch (e) {
    setSearchError((e as AxiosError<{ message?: string }>).response?.data?.message || 'Failed to search');
    setResults();
  }
  setIsLoading(false);
};
